module.exports = ".error {\n  color: red;\n  font-style: italic; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/dialog-edit-coordinates/dialog-edit-coordinates.component.scss
// module id = ./src/app/shared/dialog-edit-coordinates/dialog-edit-coordinates.component.scss
// module chunks = main